// components/WalletInstructions.js
import React from "react";
import { FaWallet, FaInfoCircle, FaCheckCircle } from "react-icons/fa";

const WalletInstructions = () => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6 mt-6 border border-green-100">
      <div className="flex items-center gap-2 mb-4">
        <FaWallet className="text-green-500 text-xl" />
        <h2 className="text-xl font-semibold text-slate-800">
          💡 How Wallet Cashback Works
        </h2>
      </div>

      <ul className="list-disc pl-5 text-sm text-gray-700 space-y-2 leading-relaxed">
        <li>
          <strong>Cashback is added to your wallet</strong> after each successful delivery — but it will initially appear in <span className="font-medium text-yellow-600">pending state</span>.
        </li>
        <li>
          This pending cashback is not usable immediately — it is subject to automatic verification and validation against our cashback criteria.
        </li>
        <li>
          Once our system completes the check, the cashback will be <span className="font-medium text-green-600">moved to your available balance</span>, ready for use.
        </li>
        <li>
          You can use this available wallet balance as a discount on your next orders. It will be automatically applied at checkout and reflected in the order summary.
        </li>
        <li>
          Please note: This is not real money that can be withdrawn, but it acts as real value within our platform to save on future purchases.
        </li>
      </ul>
    </div>
  );
};

export default WalletInstructions;
